<template>
  <div class="visitor-documents">
    <div class="row">
      <div v-if="documents.length > 0" class="col-md-12 col-xs-12">
        <span class="name-label">Документы</span>
        <div class="document-container flex">
          <CoolLightBox
            :items="documents"
            :index="documentPreviewIndex"
            :useZoomBar="true"
            @close="closeImg()"
          />
          <a
            v-for="(document, key) in documents"
            :key="key"
            class="document"
          >
            <img
              :src="getImgSrc(document, true)"
              :title="document.title"
              alt="Откройте, чтобы посмотреть"
              class="role-button"
              @click="openImg(key)"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox'

export default {
  name: 'VisitorDocumentsBlock',

  components: {
    CoolLightBox
  },

  props: {
    documents: [Object, Array]
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      documentPreviewIndex: null
    }
  },

  computed: {
    identification() {
      return this.passport.identification
    }
  },

  methods: {
    getImgSrc(document, preview) {
      let src = document.src + (preview ? '&preview=' + preview : '')
      if (document.mediaType === 'iframe') {
        src = this.baseUrl + '/img/pdf_splash.svg'
      }

      return src
    },

    openImg(key) {
      this.documentPreviewIndex = key
    },

    closeImg() {
      this.documentPreviewIndex = null
    }
  }
}
</script>
